export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "refusal_reason_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motif de refus"])},
        "ask_quotation_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demander un nouveau devis"])},
        "reconfigure_handling_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier la prise en charge"])}
      },
      "en": {
        "refusal_reason_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refusal reason"])},
        "ask_quotation_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ask for a new quotation"])},
        "reconfigure_handling_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change the handling"])}
      }
    }
  })
}
